import styled from "styled-components";

const DropdownContent = styled("div")<{width?: string, transform?: string, minWidth?: string, bg?: string, blur?: boolean}>`
  display: none;
  position: absolute;
  width: ${(props) => (props.width ? props.width : "100%")};
  width: ${(props) =>  (props.minWidth ? props.minWidth : "150px")};
  background: ${(props) => props.bg ? props.bg : "#000D30" };
  backdrop-filter: ${(props) => props.blur ?  "blur(19.6px)": "" };
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  border: 0.5px solid #FFFFFF;
  border-radius: 10px;
  transform: ${(props) => (props.transform ? props.transform : "translate(-40%, 0%)")};

  z-index: 1;
`;
export default DropdownContent;
